import { render } from "./DragHandler.vue?vue&type=template&id=46b9d4a6&scoped=true"
const script = {}

import "./DragHandler.vue?vue&type=style&index=0&id=46b9d4a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46b9d4a6"

export default script